<template>
  <div class="vg-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "VgCard"
}
</script>

<style scoped>
.vg-card {
  box-sizing: border-box;
  position: relative;
  margin: 10px 15px;
  background: #FFFFFF;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  padding: 0;
  overflow: hidden;
}

.vg-card.hidden {
  background: none;
  box-shadow: none;
  overflow: visible;
}

.vg-card.padding{
  padding: 10px;
}

.vg-card.no-margin{
  margin: 0;
}
</style>
